<!-- svelte-ignore unused-export-let -->
<script lang="ts">
    import News0 from "./part-components/news-0/News0.svelte";
    import News1 from "./part-components/news-1/News1.svelte";
    import News2 from "./part-components/news-2/News2.svelte";
    import News3 from "./part-components/news-3/News3.svelte";

    export let id: string;
    export let code: string;

    export let queryParams: any = {};
    export let client: any = [];
    export let post: any = [];
    export let formShareSocialMedia = false;
    export let durationTimeCopyToClipboard: any;
    export let idContent: number = 0;
    export let isCopyToClipboard: boolean = false;
    export let handleFromShareSocialMedia: any = () => {};
    export let handleCopyLinkToClipboard: any = () => {};
</script>

{#if code === "NEWSV0"}
    <News0
        {queryParams}
        {client}
        {post}
        {formShareSocialMedia}
        {idContent}
        {durationTimeCopyToClipboard}
        {isCopyToClipboard}
        {handleCopyLinkToClipboard}
    />
{:else if code === "NEWSV1"}
    <News1
        {client}
        {post}
        {formShareSocialMedia}
        {idContent}
        {durationTimeCopyToClipboard}
        {isCopyToClipboard}
        {handleCopyLinkToClipboard}
    />
{:else if code === "NEWSV2"}
    <News2
        {post}
        {handleFromShareSocialMedia}
        {durationTimeCopyToClipboard}
        {isCopyToClipboard}
    />
{:else if code === "NEWSV3"}
    <News3
        {client}
        {post}
        {formShareSocialMedia}
        {idContent}
        {durationTimeCopyToClipboard}
        {isCopyToClipboard}
        {handleCopyLinkToClipboard}
    />
{/if}

<style lang="scss">
</style>
